// SMART DEMO — Nexora Consulting asset manifest (FINAL EXPORT)
// Kontrollü static asset paketi için TEK KAYNAK path tanımı.
//
// Bu dosya yalnızca PATH tanımlar; binary (image/video) üretmez, indirmez.
// Kullanıcı projeyi download ettikten sonra binary dosyaları public/ altındaki
// exact klasörlere koyar ve local build alır. HİÇBİR .ts/.tsx dosyasına dokunmaz.
//
// Final asset seti (15 binary):
//   1 logo + 4 digital-marketing + 4 web-software + 4 strategy + 2 video
//
// Dış URL / hotlink / stock / Stable Diffusion external URL YOK.
// Readdy Files / Supabase Storage YOK — tüm media kullanıcının kendi serverından.
// Sahte gerçek firma YOK — "Nexora Consulting" tamamen kurgu demo markadır.

export const NEXORA_CONSULTING_ASSET_ROOT = "/demo-presets/professional/nexora-consulting";

export interface NexoraConsultingManifest {
  logo: string;
  digitalMarketing: string[];
  webSoftware: string[];
  strategy: string[];
  videos: string[];
}

export const NEXORA_CONSULTING_MANIFEST: NexoraConsultingManifest = {
  logo: `${NEXORA_CONSULTING_ASSET_ROOT}/logo/logo.webp`,
  digitalMarketing: [
    `${NEXORA_CONSULTING_ASSET_ROOT}/digital-marketing/01.webp`,
    `${NEXORA_CONSULTING_ASSET_ROOT}/digital-marketing/02.webp`,
    `${NEXORA_CONSULTING_ASSET_ROOT}/digital-marketing/03.webp`,
    `${NEXORA_CONSULTING_ASSET_ROOT}/digital-marketing/04.webp`,
  ],
  webSoftware: [
    `${NEXORA_CONSULTING_ASSET_ROOT}/web-software/01.webp`,
    `${NEXORA_CONSULTING_ASSET_ROOT}/web-software/02.webp`,
    `${NEXORA_CONSULTING_ASSET_ROOT}/web-software/03.webp`,
    `${NEXORA_CONSULTING_ASSET_ROOT}/web-software/04.webp`,
  ],
  strategy: [
    `${NEXORA_CONSULTING_ASSET_ROOT}/strategy/01.webp`,
    `${NEXORA_CONSULTING_ASSET_ROOT}/strategy/02.webp`,
    `${NEXORA_CONSULTING_ASSET_ROOT}/strategy/03.webp`,
    `${NEXORA_CONSULTING_ASSET_ROOT}/strategy/04.webp`,
  ],
  videos: [
    `${NEXORA_CONSULTING_ASSET_ROOT}/videos/01.mp4`,
    `${NEXORA_CONSULTING_ASSET_ROOT}/videos/02.mp4`,
  ],
};